import axios from "axios";
import { BASE_URL } from '../../Utils/base_url';

const AjoutePresentation = async (data) => {
  return await axios.post(`${BASE_URL}/api/restaurant/ajouteProfile`, data, {
    headers: {
      'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
    }
  });
}
const AffichePresentation = async (idRestaurant) => {
  return await axios.get(`${BASE_URL}/api/restaurant/afficheRestaurant/${idRestaurant}`, {
    headers: {
      'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
    }
  });
}


const AfficheData = async () => {
  return await axios.get(`${BASE_URL}/api/restaurant/afficheData`, {
    headers: {
      'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
    }
  });
}

export { AjoutePresentation, AffichePresentation, AfficheData }